import LoadingLogo from '@/components/atoms/LoadingLogo';
import { TOrganizationSuperAdminExtended } from '@/types/Organization.types';
import { Text, VStack } from '@chakra-ui/react';
import React from 'react';
import DeactivateOrganization from './deactivation/DeactivateOrganization';
import ReactivateOrganization from './deactivation/ReactivateOrganization';

type Props = {
  organizationData: TOrganizationSuperAdminExtended | undefined;
  isLoading: boolean;
};

const DeactivationTab = ({ organizationData, isLoading }: Props) => {
  const isActive = organizationData?.isActive;

  return (
    <VStack flex={1} width={'100%'} paddingTop={'30px'}>
      <Text variant={'loraMediumTitle'}>{isActive ? 'Deactivate' : 'Reactivate'}</Text>
      {isLoading && (
        <VStack flex={1} justifyContent={'center'} alignItems={'center'}>
          <LoadingLogo />
        </VStack>
      )}
      {!isLoading && organizationData && (
        <>
          {isActive && <DeactivateOrganization organizationData={organizationData} />}
          {!isActive && <ReactivateOrganization organizationData={organizationData} />}
        </>
      )}
    </VStack>
  );
};

export default DeactivationTab;
